import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background: transparent;
    border-radius: 1000px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 10px;
    width: 40px;
    height: 40px;
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-radius: 12px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 8px 16px;
    background-color: ${theme.v2.colors.neutral.highPure};
    height: 40px;
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 8px 12px;
    }
  `}
`;

export const Dot = styled.span`
  ${({ theme }) => css`
    min-width: 16px;
    min-height: 16px;
    border-radius: 100%;
    background-color: ${theme.v2.colors.feedback.attentionPure};
    filter: drop-shadow(0 0 5px ${theme.v2.colors.feedback.attentionPure});
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    letter-spacing: -0.176px;
    line-height: 1.5;
    white-space: nowrap;

    strong {
      font-weight: ${theme.v2.font.weights.bold};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Cta = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 4px;
    justify-content: center;
    letter-spacing: -0.176px;
    line-height: 1.5;
    white-space: nowrap;

    button {
      transform: rotate(90deg);
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
